import { useTranslation } from "react-i18next";

/**
 * useArticleLocale
 *
 * Single source of truth for language-aware article field selection.
 * Returns the localised version of each field, falling back to English
 * when the Russian translation is not available (e.g. local static articles
 * or Sanity documents where the RU fields haven't been filled yet).
 *
 * Usage:
 *   const { title, description, body, toc } = useArticleLocale(article);
 */
export function useArticleLocale(article) {
  const { i18n } = useTranslation();
  const isRu = i18n.language === "ru";

  if (!article) return {};

  return {
    title:       (isRu && article.titleRu)       || article.title,
    description: (isRu && article.descriptionRu) || article.description,
    body:        (isRu && article.bodyRu)        || article.body        || null,
    toc:         (isRu && article.tocRu?.length ? article.tocRu : null) || article.toc || [],
    faq:         (isRu && article.faqRu?.length ? article.faqRu : null) || article.faq || [],
  };
}
